export default __webpack_public_path__ + "static/media/dercam_input_template_multi_node_v59.13cd780e.xlsx";